import { render, staticRenderFns } from "./activity_bargain_edit.vue?vue&type=template&id=afc4fb8a&scoped=true"
import script from "./activity_bargain_edit.vue?vue&type=script&lang=js"
export * from "./activity_bargain_edit.vue?vue&type=script&lang=js"
import style0 from "./activity_bargain_edit.vue?vue&type=style&index=0&id=afc4fb8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4fb8a",
  null
  
)

export default component.exports